import { useState } from 'react'
import Hosts from '../../../../../../core/functions/hosts'
import {
  Alert,
  Box,
  Button,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { AdminTransferResponse } from '../../../../../../core/types/Admin'

const UserSettingExtractTransferQrCode = ({
  data,
}: {
  data: AdminTransferResponse
}) => {
  const [copied, setCopied] = useState(false)

  const handleCopyClick = async () => {
    await Hosts.copyTextToClipboard(data.pixQrCode ?? '')
    setCopied(true)
  }

  return (
    <Stack
      direction="column"
      width="100%"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{ py: 1 }}
    >
      <Typography
        color="#38393B"
        fontSize="18px"
        lineHeight="24px"
        fontWeight={700}
      >
        Escaneie o QR Code
      </Typography>
      <img src={data.pixUrl ?? ''} alt="qrCode" />

      <Stack direction="row" spacing={2} width="100%" alignItems="center">
        <Box width="100%" height="1px" sx={{ backgroundColor: 'divider' }} />
        <Typography>ou</Typography>
        <Box width="100%" height="1px" sx={{ backgroundColor: 'divider' }} />
      </Stack>

      <Typography
        color="#38393B"
        fontSize="18px"
        lineHeight="24px"
        fontWeight={700}
      >
        Copie e cole o código
      </Typography>

      <TextField
        fullWidth
        aria-readonly
        size="small"
        value={data.pixQrCode}
        maxRows={1}
        inputProps={{
          'data-testid': 'paymentQrCode',
        }}
        sx={{ maxWidth: 'sm' }}
      />
      <Button
        fullWidth
        variant="contained"
        size="large"
        onClick={handleCopyClick}
        startIcon={<ContentCopyIcon />}
        data-testid="buttonCopyQrCode"
        sx={{ textTransform: 'none' }}
      >
        Copiar Código
      </Button>

      <Snackbar
        open={copied}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        message="Código copiado"
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
      >
        <Alert
          variant="filled"
          onClose={() => setCopied(false)}
          severity="info"
          sx={{ width: '100%' }}
        >
          Código copiado!
        </Alert>
      </Snackbar>
    </Stack>
  )
}

export default UserSettingExtractTransferQrCode
